<template>
  <roe-plan-design-edit-form
    :designs="designs"
    name="Employer Other"
    :labels="['Eligibility', 'Amount', 'Misc', 'Vesting']"
    :view-input="employerOther"
    :form="$v.editableDesign"
  >
    <div class="right-panel-form-row-wrap">
      <div class="right-panel-label-wrap">
        <div class="light-label">
          Do you have an Employer Other Contribution?
        </div>
      </div>
      <div class="right-panel-form-row">
        <div class="form-unit">
          <roe-employer-other-select
            :design="$v.editableDesign"
          ></roe-employer-other-select>
        </div>
      </div>

      <template v-if="showForm(editableDesign)">
        <div class="right-panel-label-wrap">
          <div class="light-label">
            Does the plan have an age requirement for Employer Other
            Contributions?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-other-age-requirement-select
              :design="$v.editableDesign"
            ></roe-employer-other-age-requirement-select>
          </div>
        </div>

        <template v-if="showAgeRequirement(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">
              Age Requirement (AR)
            </div>
          </div>
          <div class="right-panel-form-row">
            <div class="form-unit">
              <roe-employer-other-age-requirement-years-input
                :design="$v.editableDesign"
              ></roe-employer-other-age-requirement-years-input>
            </div>
            <div class="form-unit">
              <roe-employer-other-age-requirement-months-input
                :design="$v.editableDesign"
              ></roe-employer-other-age-requirement-months-input>
            </div>
          </div>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Does the plan have a service requirement for Employer Other
            Contributions?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-other-service-requirement-select
              :design="$v.editableDesign"
            >
            </roe-employer-other-service-requirement-select>
          </div>
        </div>

        <template v-if="showServiceRequirement(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">Service Requirement (SR)</div>
          </div>
          <div class="right-panel-form-row">
            <div class="form-unit">
              <roe-employer-other-service-requirement-months-input
                :design="$v.editableDesign"
              ></roe-employer-other-service-requirement-months-input>
            </div>
          </div>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Is the Other Contribution fixed every year or can it vary from year
            to year?
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-other-type-select
              :design="$v.editableDesign"
            ></roe-employer-other-type-select>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Formula used for the Employer Other Contribution
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-other-formula-select :design="$v.editableDesign">
            </roe-employer-other-formula-select>
          </div>
        </div>

        <template
          v-if="
            showCompensationPercentOrDollarLimit(editableDesign) ||
              showFlatDollarAmount(editableDesign) ||
              showIntegratedBase(editableDesign)
          "
        >
          <template v-if="showCompensationPercentOrDollarLimit(editableDesign)">
            <div class="right-panel-label-wrap">
              <div class="light-label">Percent of Compensation</div>
            </div>
            <div class="right-panel-form-row">
              <div class="form-unit">
                <roe-employer-other-compensation-percent-input
                  :design="$v.editableDesign"
                ></roe-employer-other-compensation-percent-input>
              </div>
            </div>

            <!--Dollar limit-->
            <div class="right-panel-label-wrap">
              <div class="light-label">
                Is there a dollar limit for Employer Other Contributions?
              </div>
            </div>
            <div class="right-panel-form-row">
              <div class="form-unit">
                <roe-employer-other-dollar-maximum-radio
                  :design="$v.editableDesign"
                >
                </roe-employer-other-dollar-maximum-radio>
              </div>
            </div>

            <template v-if="showDollarLimitAmount(editableDesign)">
              <div class="right-panel-label-wrap">
                <div class="light-label">
                  Maximum Employer Other Contribution
                </div>
              </div>
              <div class="right-panel-form-row">
                <div class="form-unit">
                  <roe-employer-other-dollar-maximum-input
                    :design="$v.editableDesign"
                  >
                  </roe-employer-other-dollar-maximum-input>
                </div>
              </div>
            </template>
          </template>

          <template v-if="showFlatDollarAmount(editableDesign)">
            <div class="right-panel-label-wrap">
              <div class="light-label">Flat Dollar Amount</div>
            </div>
            <div class="right-panel-form-row">
              <div class="form-unit">
                <roe-employer-other-flat-dollar-input
                  :design="$v.editableDesign"
                >
                </roe-employer-other-flat-dollar-input>
              </div>
            </div>
          </template>

          <template v-if="showIntegratedBase(editableDesign)">
            <div class="right-panel-label-wrap">
              <div class="light-label">Amount</div>
            </div>
            <div class="right-panel-form-row">
              <div class="form-unit">
                <roe-employer-other-integrated-wage-base-input
                  :design="$v.editableDesign"
                ></roe-employer-other-integrated-wage-base-input>
              </div>
            </div>

            <div class="right-panel-label-wrap">
              <div class="light-label">Compensation below</div>
            </div>
            <div class="right-panel-form-row">
              <div class="form-unit">
                <roe-employer-other-integrated-percent-below-input
                  :design="$v.editableDesign"
                ></roe-employer-other-integrated-percent-below-input>
              </div>
            </div>

            <div class="right-panel-label-wrap">
              <div class="light-label">Compensation above that amount</div>
            </div>
            <div class="right-panel-form-row">
              <div class="form-unit">
                <roe-employer-other-integrated-percent-above-input
                  :design="$v.editableDesign"
                ></roe-employer-other-integrated-percent-above-input>
              </div>
            </div>
          </template>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Funding Frequency
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-other-funding-frequency-select
              :design="$v.editableDesign"
            >
            </roe-employer-other-funding-frequency-select>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Hire Date For Employer Other
          </div>
        </div>
        <div class="right-panel-form-row">
          <div class="form-unit">
            <roe-employer-other-hire-date-input :design="$v.editableDesign">
            </roe-employer-other-hire-date-input>
          </div>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            End-of-year (EOY) requirement applies
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-other-e-o-y-requirement-radio
            :design="$v.editableDesign"
          ></roe-employer-other-e-o-y-requirement-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Plan Year Service Requirement applies
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-other-service-req-applies-select
            :design="$v.editableDesign"
          ></roe-employer-other-service-req-applies-select>
        </div>

        <template v-if="showHoursOrMonths(editableDesign)">
          <div class="right-panel-label-wrap">
            <div class="light-label">
              Plan Year Service Requirement
            </div>
          </div>
          <div class="right-panel-form-row">
            <roe-employer-other-service-req-applies-input
              :design="$v.editableDesign"
            ></roe-employer-other-service-req-applies-input>
          </div>
        </template>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Overtime
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-other-overtime-radio
            :design="$v.editableDesign"
          ></roe-employer-other-overtime-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Bonuses
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-other-bonuses-radio
            :design="$v.editableDesign"
          ></roe-employer-other-bonuses-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Commissions
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-other-comissions-radio
            :design="$v.editableDesign"
          ></roe-employer-other-comissions-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            Shift Differential
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-employer-other-shift-differential-radio
            :design="$v.editableDesign"
          ></roe-employer-other-shift-differential-radio>
        </div>

        <div class="right-panel-label-wrap">
          <div class="light-label">
            The Vesting Schedule for Employer Other Contribution
          </div>
        </div>
        <div class="right-panel-form-row">
          <roe-vesting-select
            :design="$v.editableDesign"
            type="other"
          ></roe-vesting-select>
        </div>

        <roe-vesting-percent-right-panel-inputs
          v-if="showVestingImmediateGraded(editableDesign)"
          :vestingYears="[[1, 2, 3], [4, 5, 6]]"
          :design="$v.editableDesign"
          type="other"
        ></roe-vesting-percent-right-panel-inputs>

        <roe-vesting-percent-right-panel-inputs
          v-if="showVestingImmediateCliff(editableDesign)"
          :vestingYears="[[1, 2, 3]]"
          :design="$v.editableDesign"
          type="other"
        ></roe-vesting-percent-right-panel-inputs>
      </template>
    </div>

    <template v-slot:survey>
      <roe-survey-bar label="0%" :percent="0.91"></roe-survey-bar>
      <roe-survey-bar label="1% - 2%" :percent="0.01"></roe-survey-bar>
      <roe-survey-bar label="2% - 3%" :percent="0.03"></roe-survey-bar>
      <roe-survey-bar label="3% - 4%" :percent="0.02"></roe-survey-bar>
      <roe-survey-bar label="4% - 5%" :percent="0.01"></roe-survey-bar>
      <roe-survey-bar label="5% - 6%" :percent="0.01"></roe-survey-bar>
      <roe-survey-bar label="> 6%" :percent="0.01"></roe-survey-bar>
    </template>
  </roe-plan-design-edit-form>
</template>

<script>
import RoePlanDesignEditForm from "@/components/alternative-designs/_shared/EditForm";
import RoeSurveyBarLight from "@/components/charts/SurveyBarLight";
import RoeSurveyBar from "@/components/charts/SurveyBar";
import EmployerOtherMixin from "@/components/_shared/inputs/design/_mixins/EmployerOtherMixin";
import {
  RoeEmployerOtherSelect,
  RoeEmployerOtherAgeRequirementSelect,
  RoeEmployerOtherAgeRequirementYearsInput,
  RoeEmployerOtherAgeRequirementMonthsInput,
  RoeEmployerOtherServiceRequirementSelect,
  RoeEmployerOtherServiceRequirementMonthsInput,
  RoeEmployerOtherFormulaSelect,
  RoeEmployerOtherCompensationPercentInput,
  RoeEmployerOtherDollarMaximumRadio,
  RoeEmployerOtherDollarMaximumInput,
  RoeEmployerOtherFlatDollarInput,
  RoeEmployerOtherIntegratedWageBaseInput,
  RoeEmployerOtherIntegratedPercentBelowInput,
  RoeEmployerOtherIntegratedPercentAboveInput,
  RoeVestingSelect,
  RoeVestingPercentRightPanelInputs,
  RoeEmployerOtherEOYRequirementRadio,
  RoeEmployerOtherServiceReqAppliesInput,
  RoeEmployerOtherServiceReqAppliesSelect,
  RoeEmployerOtherBonusesRadio,
  RoeEmployerOtherComissionsRadio,
  RoeEmployerOtherOvertimeRadio,
  RoeEmployerOtherShiftDifferentialRadio,
  RoeEmployerOtherFundingFrequencySelect,
  RoeEmployerOtherTypeSelect,
  RoeEmployerOtherHireDateInput
} from "@/components/_shared/inputs/design/employer-other";
import { mapGetters } from "vuex";

export default {
  name: "RoeEmployerOther",
  mixins: [EmployerOtherMixin],
  components: {
    RoeEmployerOtherHireDateInput,
    RoeSurveyBar,
    RoeSurveyBarLight,
    RoePlanDesignEditForm,
    RoeVestingPercentRightPanelInputs,
    RoeVestingSelect,
    RoeEmployerOtherDollarMaximumInput,
    RoeEmployerOtherDollarMaximumRadio,
    RoeEmployerOtherFundingFrequencySelect,
    RoeEmployerOtherIntegratedPercentAboveInput,
    RoeEmployerOtherIntegratedPercentBelowInput,
    RoeEmployerOtherIntegratedWageBaseInput,
    RoeEmployerOtherFlatDollarInput,
    RoeEmployerOtherCompensationPercentInput,
    RoeEmployerOtherFormulaSelect,
    RoeEmployerOtherTypeSelect,
    RoeEmployerOtherServiceRequirementMonthsInput,
    RoeEmployerOtherServiceRequirementSelect,
    RoeEmployerOtherAgeRequirementMonthsInput,
    RoeEmployerOtherAgeRequirementYearsInput,
    RoeEmployerOtherAgeRequirementSelect,
    RoeEmployerOtherSelect,
    RoeEmployerOtherEOYRequirementRadio,
    RoeEmployerOtherServiceReqAppliesInput,
    RoeEmployerOtherServiceReqAppliesSelect,
    RoeEmployerOtherBonusesRadio,
    RoeEmployerOtherComissionsRadio,
    RoeEmployerOtherOvertimeRadio,
    RoeEmployerOtherShiftDifferentialRadio
  },
  props: {
    designs: {
      type: Array,
      required: true
    }
  },
  validations() {
    return {
      editableDesign: this.employerOtherValidations(this.editableDesign)
    };
  },
  computed: {
    ...mapGetters(["editableDesign", "employerOther"])
  }
};
</script>
